import { FC, Fragment } from 'react';

import { CheckOutline, PlusOutline } from '@bonusly/design-system';

interface SuggestionIconProps {
	isSelected: boolean;
	isSuggested: boolean;
}
export const SuggestionIcon: FC<SuggestionIconProps> = ({ isSelected, isSuggested }) => {
	if (isSelected) {
		return <CheckOutline size="xs" color="primary.fgStrong" />;
	}
	if (isSuggested) {
		return <PlusOutline size="xs" />;
	}
	return <Fragment />;
};
